module.exports = __webpack_public_path__ + "images/album_130.4d34ea930e8b0525994022e6f98df802.png";